// extracted by mini-css-extract-plugin
export default {"cls1":"gddn02Qmqp6vGM6L6pLy","cls2":"ZwW4_x96izvWBBzp247L gddn02Qmqp6vGM6L6pLy"};